/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from 'react'
import { connect } from 'react-redux'

import SlotsNav from './SlotsNav.jsx'
import betsoftList from './betsoft/assets/index'
import betsolutionsList from './betsolutions/assets/index'
import tomhornList from './tomhorn/assets/index'
import slotsList from './slotList'
import NewGamesBanner from './NewGamesBanner.jsx'
import Loader from '../../../../shared/components/Loader.jsx'
import { openBetsolutionGameWindow } from '../../../../config/games'
import GamesRedirect from '../../../../hoc/GamesRedirect.jsx'
import { getGamblerInfo } from '../../../../actions/creators/GamblerInfo'
import { defineMessages, injectIntl } from 'react-intl'

const messages = defineMessages({
  user_blocked: {
    id: 'sign_in.errors.user_blocked',
    defaultMessage: 'Ваша учетная запись временно заблокирована! Обратитесь в техподдержку',
  },
});

class SlotsGames extends Component {
  static contextTypes = {
    footer: React.PropTypes.object,
  }
  state = {
    loading: false,
  }

  componentDidMount() {
    const { getGamblerInfo,gamblerId } = this.props;

    if (gamblerId) {
      getGamblerInfo();
    }
  }

  userBlockedAlert = () => {
    return window.alert(this.props.intl.formatMessage(messages.user_blocked));
  }

  clickBetsolution = (game) => {
    this.setState({ loading: true })

    const { gamblerInfo, gamblerId } = this.props;
    if (gamblerInfo && gamblerInfo.data && gamblerInfo.data.IsBlocked) {
      this.userBlockedAlert();
    } else if (gamblerId) {
      fetch(`/api/games-betsolutions/`)
        .then((r) => r.json())
        .then(({token}) => {
          this.loadGame(game, token)
        })
    } else {
      if (game.productId === 2) {
        this.loadGame(game)
      } else {
        this.props.dispatch({ type: 'BEGIN_SIGNIN' })
        this.setState({ loading: false })
      }
    }
  }

  loadGame = (game, token) => {
    const { langType } = this.props
    const config = {
      Token: token ? token : '54D2A7CA-FD87-46D4-A5A0-6BC0372C43EE',
      MerchantId: token ? 5096 : 105,
      Lang: langType === 'ru' ? 'ru-RU' : 'en-US',
      GameId: game.id,
      ProductId: game.productId,
      IsFreeplay: 1,
      Platform: 'desktop',
      IframeContainerId: 'iframeContainer',
      IframeId: 'gameIFrame',
      GameOpenType: 'iframe',
      AuthUrl: token ? 'https://auth-ru.betsolutions.com/auth/auth/' : 'https://auth-tr.betsolutions.com/auth/auth/',
    }
    if (game.productId === 1) {
      config.TableGamesLobbyPageId = 1
      if (!token) {
        config.MerchantId = 34
        config.Token = '17B437DF-AB78-44CB-904F-621704BC610F'
      }
    }
    if (token) {
      config.IsFreeplay = 0
    }
    openBetsolutionGameWindow(config)
    this.setState({ loading: false })
  }

  clickBetsoft = (game) => {
    const { gamblerInfo } = this.props;
    if (gamblerInfo && gamblerInfo.data && gamblerInfo.data.IsBlocked) {
      this.userBlockedAlert();
    } else {
      this.props.router.push(`/games/slots/betsoft/${game.id}`)
    }
  }
  clickTomHorn = (game) => {
    const { gamblerInfo } = this.props;
    if (gamblerInfo && gamblerInfo.data && gamblerInfo.data.IsBlocked) {
      this.userBlockedAlert();
    } else {
      this.props.router.push(`/games/slots/tom-horn/${game.id}`)
    }
  }

  render() {
    const { loading } = this.state
    const { languageId, countryCode, gamblerInfo } = this.props
    const isNotUz = countryCode !== 'UZ'

    return (
      <div>
        {loading || (gamblerInfo && gamblerInfo.fetching) && <Loader />}
        <div className="slots--wrapper">
          <SlotsNav languageId={languageId} countryCode={countryCode} />
          {isNotUz && <NewGamesBanner />}

          <div className="slots__list">
            {slotsList(betsoftList, this.clickBetsoft)}
            {isNotUz && slotsList(betsolutionsList, this.clickBetsolution)}
            {slotsList(tomhornList, this.clickTomHorn)}
          </div>
        </div>
        {this.context.footer}
      </div>
    )
  }
}

export default GamesRedirect(connect((state) => {
  const user = state.auth.get('user')
  return {
    gamblerId: user && user.get('gamblerId'),
    languageId: state.application.get('languageId'),
    countryCode: state.application.get('countryCode'),
    gamblerInfo: state.application.get('gamblerInfo'),
  }
}, {getGamblerInfo})(injectIntl(SlotsGames)))



// WEBPACK FOOTER //
// ./js/sport-betting/components/games/slots/index.js